import { PUBLIC_VOTING_STATUS_ENUM, VOTED_FILTER_ENUM, VOTING_TYPE_ENUM } from "@antipartido-inc/contracts-ifaces"

export default {
  noOpenVotings: "There are no open votings",
  status: {
    title: "Status",
    options: {
      [PUBLIC_VOTING_STATUS_ENUM.UPCOMING]: "Upcoming",
      [PUBLIC_VOTING_STATUS_ENUM.ACTIVE]: "Active",
      [PUBLIC_VOTING_STATUS_ENUM.CLOSED]: "Closed",
    },
  },
  type: {
    title: "Type",
    options: {
      [VOTING_TYPE_ENUM.PROPOSAL]: "Proposal",
      [VOTING_TYPE_ENUM.CANDIDATE]: "Candidate",
    },
  },
  votedFilter: {
    title: "Participation",
    options: {
      [VOTED_FILTER_ENUM.VOTED]: "Voted",
      [VOTED_FILTER_ENUM.NOT_VOTED]: "Not Voted",
    },
  },
  timeRemaining: {
    finished: "Finished",
    startsToday: "Starts today",
    startsIn: "Starts in {{days}} days",
    endsToday: "Ends today",
    endsIn: "Ends in {{days}} days",
  },
  title: "Votings",
  welcome: "Welcome to Antipartido",
  loading: "Loading votings...",
  votingsDescription: "Participate in decisions that affect you!",
  filter: "Filter",
  resetFilters: "Reset",
  applyFilters: "Apply",
  results: "results",
  vote: "Vote",
  editVote: "Edit vote",
  viewVoting: "View voting",
  voted: "Voted",
  localProposal: "Local Proposal",
  globalProposal: "Global Proposal",
  participants: "Participants",
  startsOn: "Starts on",
  endsOn: "Ends on",
  endsToday: "Ends today",
  finishedOn: "Finished on {{date}}",
  remainingDays: "days remaining",
  startsIn: "Starts in",
  startsToday: "Starts today",
  days: "days",
  progress: "Time remaining",
  loadMore: "Load more",
  noVotings: "No votings match the selected filters",
  citizenId: "CURP",
  myVotings: "Votings you have participated in",
  fewVotingsInfo: {
    title: "You are now part of the census!",
    message:
      "From now on, you will see and be able to participate in every new voting you are included in.",
  },
  subscriptionRequired: {
    title: "Why can't I vote?",
    message: "You must be subscribed to vote",
    button: "SUBSCRIBE",
  },
  censusCountdown: {
    title: "In 1 minute you will be able to see the votings",
    message:
      "We need 1 minute to register you in the census through the blockchain, once you are registered you will be able to see the votings. Take this opportunity to subscribe since you won't be able to vote without a subscription.",
    button: "SUBSCRIBE",
  },
  subscriptionExpiring: {
    title: "Your subscription is about to expire",
    message:
      "Renew your subscription to continue participating, otherwise when it expires you will not be able to continue voting",
    button: "RENEW",
  },
}
